/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React,{useContext, useState,useCallback,useEffect} from 'react'
import { AllRolesList } from './roles'
import ManageRoles from '../../components/RolesSelection'
import { useSelector } from 'react-redux'
import authSlice from '../auth/authSlice'
import Input from '../../components/InputBox'
import BranchSelection from '../../components/BranchSelection'
import BranchSelect from './Components/BranchSelection'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import GlobalContext from '../../components/Context/GloablContext'
import Loader from '../../components/Loader'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { CognitoCurrentData } from '../../CommonMethods/CognitoData'
import { dataService } from '../../services/data.services'
import CardHeader from '../../components/CardHeader'
import { pushOrRemoveElement } from '../../CommonMethods/pushOrRemoveElement'
import Toast from '../../components/Toast'
import CustomOverLay from '../../components/CustomOverlay'

export default function AddNewInstitutionUser({edit}) {
    
    const {email_address}=useParams()
    const {MandatoryErrorMessage,setMandatoryErrorMessage,setToastmessage,isSideNavBar}=useContext(GlobalContext)
    const location = useNavigate()
    const {userType}=useSelector(state => state.auth);
    const [editData, seteditData] = useState({})
    const [loading, setloading] = useState(false);
    const [customError, setcustomError] = useState([]);
    const [wholeData, setwholeData] = useState({})
    const [searchParams, setSearchParams] = useSearchParams('')
    const initialState={
        "first_name": "",
        "mobile_number": "",
        "email_address": "",
        "last_name": "",
        "branches": [],
        "user_type": userType,
        "institution_id": "",
        "roles": []
    }
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const handleFetch =useCallback(
        async() => {
            let response = await dataService.GetAPI(`users/${email_address}`);
            if(response.data.status===200){
                setwholeData(response.data.data.data)
                const Getdata=response.data.data.data
                
                let rolesArray = Getdata.roles || [];
                const anyCollectFeeRoleExists = rolesArray.some(role => role.startsWith("collect-fee"));
                if((rolesArray.includes("collect-fee") && !anyCollectFeeRoleExists) ||
                    (rolesArray.includes("collect-fee") && rolesArray.includes("collect-fee:receipt")))   
                {
                    rolesArray = [...rolesArray, "collect-fee:receipt"];
                }
                Getdata.roles = rolesArray;

                seteditData(JSON.parse(JSON.stringify(Getdata)))
                setstate({
                    "first_name": Getdata.first_name,
                    "mobile_number": Getdata.mobile_number,
                    "email_address": Getdata.email_address,
                    "last_name": Getdata.last_name,
                    "branches": Getdata.branches,
                    "roles": Getdata.roles

                })

            }

        },
        [email_address],
    )
    
    useEffect(() => {
        if(edit)
            handleFetch()
    }, [handleFetch])
    
    const [state, setstate] = useState(initialState);
    const [submitSelected, setsubmitSelected] = useState(false)
    const handleInput=(e)=>{
        setToastErrorMessage('')
        const {id,value}=e.target
        setstate((prv)=>({
            ...prv,
            [id]:value
        }))
    }
    const handleValidation=()=>{
        const arr=[]
        const mykeys={
            "first_name": "",
            "mobile_number": "",
            "email_address": "",
            "branches": [],
            "roles": []
        }
        Object.keys(mykeys).map((item)=>{
            if(state[item]===''){
                arr.push(item)
            }
        })
        return arr?.length===0

    }
    const handleSubmit=async(e)=>{
        setloading(true)
        e.preventDefault()
        setcustomError([])
        const user = await CognitoCurrentData();
        setloading(true)
        setsubmitSelected(true);
        if(!handleValidation()){
            setloading(false);
            setToastErrorMessage('Please fill in all the mandatory fields')

            return
        }
        if(state.roles?.length===0 || state.branches?.length===0){
            setloading(false);
            setToastErrorMessage('Please fill in all the mandatory fields')
            return 
        }
        const errors = [];  // Array to store validation errors
        if (validateEmail(state.email_address.trim())) {
            errors.push('email_address');
        }
        
        if (state.mobile_number?.length !== 10) {
            errors.push('mobile_number');
        }
        
        if (errors.length > 0) {
            setToastErrorMessage("Please enter valid details");
            let updatedCustomError = customError;
            
            // Add errors to customError array
            errors.forEach(error => {
                updatedCustomError = [...errors, error];
            });
            setcustomError(updatedCustomError);
            setloading(false);
            return;
        }
        try {
            const {first_name,last_name,email_address,roles,branches,mobile_number}=state;  
            const selectedRoles = [...new Set(roles)]
            let body = 
            {
                "first_name": first_name,
                "mobile_number": mobile_number,
                "last_name": last_name,
                "branches": branches,
                "user_type": 'institution-user',
                "institution_id": user['custom:institution_id'],
            }
            let response
            if(edit){
                body.roles=selectedRoles
                
                response = await dataService.PatchAPI(body,`users/${email_address}`);

            }else{
                body.roles=selectedRoles;
                body.email_address=email_address,

                response = await dataService.PostAPI(body,`users`);

            }

            setToastmessage(`Institution user ${edit?'updated':'added'} successfully`)
            edit ? location(`/manage-institution-users?${searchParams.toString()}`) : location('/manage-institution-users')            
        } catch (error) {
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }

    }
    const handleSelection=(val)=>{
        setsubmitSelected(false);

        setstate((prv) => ({
            ...prv,
            roles: prv.roles.includes(val)
                ? prv.roles.filter(role => role !== val)
                : [...prv.roles, val]
        }));
    }
    return (

        <CardHeader noPadding>
            <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: -"webkit-sticky;"}}>
                <h5 class="pageHeader adderror">{edit?'Edit':'Add'} Institution User</h5>
                <div class="flex items-center">
                    <button onClick={()=>edit ? location(`/manage-institution-users?${searchParams.toString()}`) : location('/manage-institution-users')} type="button" class="cancl-btn">
                        Cancel
                    </button>
                    <button
                        disabled={ loading || (edit&&Object.keys(editData)?.length===0)}
                        type="submit"
                        id='sumbit-button'
                        onClick={(e) => { e.preventDefault(); handleSubmit(e); }}
                        style={{'width':loading?'96px':'auto'}}
                        class="actn-btn onboardInstitution">
                        {!loading?edit?'Update':'Add':<span>{<Loader />}</span>}
                    </button>
                </div>
            </div>
            
            {edit && Object.keys(editData)?.length===0 && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}

            {(!edit || (edit && Object.keys(editData)?.length!==0)) && <div class="mainDataCntnrPageDiv scrollBlue_thick">
                <div class="w-[78%] mx-auto">
                    <div class="-mx-5 flex">
                        <div class="w-[45%] px-5">
                            <div class="w-full">
                                <div class="flex items-center mb-4">
                                    <label for="first_name" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">First Name</label>
                                    <Input
                                        type="text"
                                        state={state}
                                        id="first_name"
                                        handleInput={handleInput}
                                        maxLength={30}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        isMandatoryField={true}
                                        text="First name is mandatory"
                                        placeholder ="Enter First Name"
                                    />
                                </div>
                                <div class="flex items-center mb-4">
                                    <label for="last_name" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Last Name</label>
                                    <Input
                                        type="text"
                                        state={state}
                                        id="last_name"
                                        optional
                                        handleInput={handleInput}
                                        maxLength={30}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        text="Last name is mandatory"
                                        placeholder ="Enter Last Name"
                                    />
                                </div>
                                <div class="flex items-center mb-4">
                                    <label for="email_address" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Email Address</label>
                                    <Input
                                        type="text"
                                        state={state}
                                        disable={edit?true:false}
                                        id="email_address"
                                        handleInput={handleInput}
                                        maxLength={60}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        text="Email address is mandatory"
                                        placeholder ="Enter Email Address"
                                        customError={customError}
                                    />                                </div>
                                <div class="flex items-center mb-4">
                                    <label for="mobile_number" class="text-f7 font-normal text-[#031624] min-w-[130px] inline-flex">Mobile Number</label>
                                    <Input
                                        type="number"
                                        state={state}
                                        id="mobile_number"
                                        handleInput={handleInput}
                                        maxLength={10}
                                        submitSelected={submitSelected}
                                        setsubmitSelected={setsubmitSelected}
                                        text="Mobile Number is mandatory"
                                        placeholder ="Enter Mobile Number"
                                        customError={customError}
                                    />                                 </div>
                            </div>
                        </div>
                        <div class="w-[55%] px-10">
                            <div class="w-full">
                                <p class="text-f7 font-nnormal text-[#031624] pb-1">Branch Access</p>
                                <BranchSelect
                                    error={submitSelected}
                                    selected={state.branches}
                                    handleSelect={(value)=>{
                                        setsubmitSelected(false);
                                        setstate((prv)=>({
                                            ...prv,
                                            branches:value
                                        }))}
                                    }
                                />

                            </div>
                        </div>
                    </div>
                </div>
                <ManageRoles
                    rolesForUserType={AllRolesList}
                    selected={state.roles}
                    handleSelection={handleSelection}
                    error={submitSelected}
                    institution={true}/>
            </div>}
            {toastErrorMessage!=='' &&<Toast
                message={toastErrorMessage}
                type="error"
                setToastmessage={setToastErrorMessage} />}
        </CardHeader>
    )
}
